import { Component } from 'react';
import axios from 'axios';
import {
  Box,
  ToggleButtonGroup,
  ToggleButton,
  Popover
} from '@mui/material';
import { LayoutGroup, motion } from "framer-motion";
import ButtonBase from "@mui/material/ButtonBase";
import { alpha } from '@mui/material/styles';
import UserMenu from './UserMenu';
import CircularProgress from "@mui/material/CircularProgress";
import NL2026HomeIssues from './NL2026HomeIssues'
import NZ2026SeatComparisonIssues from "./NZ2026SeatComparisonIssues"
import VotersDemographics from "./VotersDemographics"
import VotersSeats from "./VotersSeats"
import PolicyView from "./PolicyView"
import NZ2026Summary from "./NZ2026Summary"
import PolicySummary from "./PolicySummary"
import { Navigate } from "react-router-dom";



// --- update THEME_OPTIONS to include title + buttonLabel ---
const THEME_OPTIONS = [
  {
    value: "Politics",
    title: "Politics",                 // <- string used for sectionTitle etc.
    buttonLabel: "Politics",
    parent: "Politics",
    show: "yes",
  },
  {
    value: "Issues",
    title: "Issues",
    buttonLabel: "Issues",
    parent: "Issues",
    show: "yes",
  },
];


const ALLOWED = new Set(THEME_OPTIONS.map(o => o.value));


export default class IssuesHome extends Component {
  constructor(props) {
    super(props);

    const initialTheme = "Politics"
  
    
    const initialOpt =
      THEME_OPTIONS.find((t) => t.value === initialTheme) || THEME_OPTIONS[0];
    const sectiontitle = initialOpt?.title ?? "";

    this.state = {
      selectedSection: initialOpt?.value ?? initialTheme,
      sectionTitle: sectiontitle,
      user: { email: "", name: "", company: "" },
      anchorEl: null,
      hoveredButton: null,
      GEEMENTENMap: null,
      BUURTMap: null,
      loading: true,
    };
  }

  applyTheme = (theme) => {
    if (!ALLOWED.has(theme)) return;

    const opt = THEME_OPTIONS.find((t) => t.value === theme);
    const sectiontitle = opt?.title ?? "";

    this.setState({
      selectedSection: theme,
      sectionTitle: sectiontitle,
    });
  };


  componentDidMount() {
    
    this._onPopState = () => {
      const selectedSection = this.state.selectedSection;
      this.applyTheme(selectedSection);
    };
    window.addEventListener('popstate', this._onPopState);
      axios.get('/api/user-info/')
      .then((response) => {
        this.setState({ user: response.data }, () => {
          console.log("user", this.state.user);
        });
      })
      .catch((error) => {
        console.error('Error fetching user info:', error);
      });
      Promise.all([
        fetch(process.env.PUBLIC_URL + "/NL_maps/netheerlandsGEEMENTEN.json").then(r => r.json()),
        fetch(process.env.PUBLIC_URL + "/NL_maps/netheerlandsBUURT.json").then(r => r.json())
        ]).then(([GEEMENTENData, BUURTData

        ]) => {
        const makeGeo = (data) => ({
            type: "FeatureCollection",
            features: (data.features || []).map(f => ({
            ...f,
            properties: { ...f.properties }
            }))
        });

        this.setState({
            GEEMENTENMap: makeGeo(GEEMENTENData),
            BUURTMap: makeGeo(BUURTData),
        loading: false   // 👈 maps are ready
        });
        });
      

    }
  
  componentWillUnmount() {
    window.removeEventListener('popstate', this._onPopState);
  };

   applyTheme = (theme) => {
    if (!ALLOWED.has(theme)) return;
    const sectiontitle = THEME_OPTIONS.find(t=> t.value === theme).label;

    this.setState({
      selectedSection: theme,
      sectionTitle: sectiontitle
    });
  };
  
  render() {

    const {
    //   isPanelOpen,
       selectedSection,
       loading,
       BUURTMap,
       GEEMENTENMap

    } = this.state;


            // 👇 Restriction logic
    if (this.state.user.email !=="" &&  this.state.user.email !== "NL_issues@stackdatastrategy.com") {
        console.log("this.state.user",this.state.user)
      return <Navigate to="/D66" replace />;
    }
       if (loading) {
      // 👇 loading screen
      return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
          <CircularProgress />
        </div>
      );
    }

    return (
        <>
      <Box sx={{ display: 'flex', height: '8vh'}}>
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'hidden',
            display: 'flex',
            width: '47.5%',
            flexDirection: 'column'
          })}
        >
         
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              px: 2,
              py: 1,
            }}
          >
            <img
              src={process.env.PUBLIC_URL + '/static/images/stack_logo.png'}
              alt="District Profiles"
              style={{ height: 50, objectFit: 'contain' }}
            />

          </Box>
        </Box>

        <Box
          sx={(theme) => ({
    flexGrow: 1,
    backgroundColor: theme.vars
      ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
      : alpha(theme.palette.background.default, 1),
    overflow: "hidden",
    display: "flex",
    width: "47.5%",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center", // ✅ centres the pill horizontally
          })}
        >
         

         <Box
  sx={(theme) => ({
      display: "inline-flex",
      alignItems: "center",
      gap: 0.5,
      p: 0.5,
      borderRadius: 99,
      bgcolor: "rgba(0,0,0,0.04)",
      height: "fit-content",
  })}
>
  <LayoutGroup id="header-tabs-group">
    {THEME_OPTIONS.filter((opt) => opt.show === "yes").map((opt) => {
      const isSelected = selectedSection === opt.value;

      const content =
          opt.title ?? opt.label ?? opt.value

      return (
        <ButtonBase
          key={opt.value}
          disableRipple
          onClick={() => this.applyTheme(opt.value)}
          sx={(theme) => ({
            position: "relative",
            px: 2.5,
            py: 0.85,
            borderRadius: 99,
            fontSize: "0.875rem",
            fontWeight: 600,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",

            // text colour (logo is unaffected)
            color: isSelected
              ? theme.palette.primary.main
              : theme.palette.text.secondary,

            transition: "color 0.2s ease, background-color 0.2s ease",

            "&:hover": {
              color: isSelected
                ? theme.palette.primary.main
                : theme.palette.text.primary,
              backgroundColor: !isSelected
                ? "rgba(0,0,0,0.04)"
                : "transparent",
            },

            zIndex: 1,
          })}
        >
          <Box sx={{ position: "relative", zIndex: 2, display: "flex", alignItems: "center" }}>
            {content}
          </Box>

          {isSelected && (
            <Box
              component={motion.div}
              layoutId="active-pill"
              transition={{ type: "spring", stiffness: 500, damping: 35 }}
              sx={{
                position: "absolute",
                inset: 0,
                borderRadius: 99,
                bgcolor: "white",
                boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                border: "1px solid rgba(0,0,0,0.02)",
                zIndex: 1,
              }}
            />
          )}
        </ButtonBase>
      );
    })}
  </LayoutGroup>


            </Box>
</Box>
     <Box
          sx={(theme) => ({
    flexGrow: 1,
    backgroundColor: theme.vars
      ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
      : alpha(theme.palette.background.default, 1),
    overflow: "hidden",
    display: "flex",
    width: "5%",
    alignItems: "center",
    justifyContent: "center", // ✅ centres the pill horizontally

          })}
>
            <UserMenu user={this.state.user} />
      </Box>
      </Box>
      
      <Box sx={{ display: 'flex', height: '92vh'}}>
        {selectedSection === "Politics" ? (
            <NL2026HomeIssues BUURTMap={BUURTMap} GEEMENTENMap={GEEMENTENMap} />
            ) : selectedSection === "Issues" ? (
            <NZ2026SeatComparisonIssues BUURTMap={BUURTMap} GEEMENTENMap={GEEMENTENMap} />
            ): null}

            

      </Box>
    </>
    );
  }

}
